export default __webpack_public_path__ + "static/media/ProximaNova-Regular.2a9ce1ea.ttf";